export default ({ background }, font) => ({
  body: {
    fontFamily: font.family,
    backgroundColor: background,
  },
});
